import * as messageService from "../../services/message.service";
import * as transmissionService from '../../services/transmission.service';


const state = {
    transmissionAll:[],
    transmissionAllActive:[],
};

const getters = {
    gettTransmissionAll:state => (state.transmissionAll),
    gettTransmissionAllActive:state => (state.transmissionAllActive),
};

const actions = {
    async fetchTransmissionAll({ commit } ){
        try {
            const response = await transmissionService.all();
            commit('setTransmissionAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchTransmissionAllActive({ commit } ){
        try {
            const response = await transmissionService.allActive();
            commit('setTransmissionAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setTransmissionAll:(state, res) => (
        state.transmissionAll =  res
    ),
    setTransmissionAllActive:(state, res) => (
        state.transmissionAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}